export default "__VITE_ASSET__BhGjbWCj__"